/**
 * @description 會員註冊階段切換用
 */
export enum SignupStep {
  ConsentNotice = 1,
  FillInMember = 2,
  PreviewMemberInfo = 3,
  OTPVerification = 4,
  SignupComplete = 5
}
